// TODO: split requires into store-ony and blog-only for lighter payloads on each platform
require('./app.js');